import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientQuestionnaireControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

export type SeverityRange = "VERY_LOW"| "LOW"| "MODERATE"| "HIGH"| "VERY_HIGH"

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  status?: boolean;
  archive?: boolean;
  review?: boolean;
  severityRange?: SeverityRange
  submittedDate?: string;
  searchString?: string;
  appointmentUuid?: string;
  submittedBy?: string;
  xTENANTID?: string;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author [Atish Bagate]
 */
export const useDashboardPatientQuestionaire = ({
  pagination,
  gridSorting,
  status,
  archive,
  review,
  submittedDate,
  severityRange,
  searchString,
  submittedBy,
  xTENANTID,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString ?? "",
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];

  const sortDirect = sortData?.sort ?? undefined;
  const sortBy = sortData?.field ?? undefined;

  return useQuery({
    queryKey: [
      "dashboard-patient-questionaire",
      pageIndex,
      pageSize,
      gridSorting,
      status,
      archive,
      review,
      submittedDate,
      severityRange,
      submittedBy,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    //  submittedDate?: string, monthFilter?: GetAllPatientQuestionnaireMonthFilterEnum, xTENANTID?: string, options?: RawAxiosRequestConfig
    queryFn: async () =>
      await new PatientQuestionnaireControllerApi(getConfigObject())
        .getAllPatientQuestionnaire(
          pageIndex, //page
          pageSize, //size
          sortBy,
          sortDirect, // sortDirection
          status,
          archive,
          review,
          searchString,
          submittedDate, //submittedDate
          undefined, //monthFilter
          submittedBy, //submittedBy
          severityRange,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
